module.exports = __webpack_public_path__ + "img/p_15.07795bec.jpg";